import React, { useState } from "react";
import { ApiEndpoint } from "../../utils/ApiEndpoint";
import { Badge, Button, Stack } from "react-bootstrap";
import * as AiIcons from "react-icons/ai";
import ModalEdit from "../../components/ModalEdit";
import CreatePartner from "./_CreatePartner";
import DetailPartnerApi from "../Generic/DetailPartnerApi";
import ShortCodesByCustomer from "./_ShortCodesByCustomer";
import { httpClient } from "../../utils/HttpClient";
import { useAuth } from "../../Context/AuthContext";
import PropTypes from "prop-types";
import { Table } from "../../components/ui/Table";
import { Tooltip } from "../../components/ui/Tooltip";
import SettingsUserAPI from "../../features/administration/customers/modal/SettingsUserAPI";
import { useQuery } from "@tanstack/react-query";
const CustomerPartners = ({ idCustomer, partnersData, setPartnersData }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [partnerIdToShow, setPartnerIdToShow] = useState(null);
  const [show, setShow] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [showInfoPartner, setShowInfoPartner] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleCloseInfo = () => setShowInfo(false);
  const handleShowInfo = () => setShowInfo(true);
  const handleShowInfoPartner = () => setShowInfoPartner(true);
  const handleCloseInfoPartner = () => setShowInfoPartner(false);
  const [visible, setVisible] = useState({
    visible: false,
    data: null,
  });

  const { refetch, isPending: isLoading } = useQuery({
    queryKey: ["services", idCustomer],
    queryFn: async () => {
      const response = await httpClient(
        "GET",
        `${ApiEndpoint}administration/services/${idCustomer}`,
        {},
        userData.token,
      );

      setPartnersData(response.data);
      return response.data;
    },
    refetchOnWindowFocus: false,
  });


  const columns = [
    {
      accessor: "cat_partner.name",
      Header: "Partner",
    },
    {
      accessor: "cat_partner.partnerid",
      Header: "API Id",
    },
    {
      accessor: "servicename",
      Header: "Servicio",
    },
    {
      accessor: "serviceid",
      Header: "Id Servicio",
    },

    {
      accessor: "description",
      Header: "Descripcion",
    },

    {
      accessor: "cat_partner.active",
      Header: "Estatus",
      Cell: (rowData) => {
        let active = rowData.row.original.cat_partner.active;
        return (
          <>
            {active ? (
              <Badge bg="success">Activo</Badge>
            ) : (
              <Badge bg="secondary">Inactivo</Badge>
            )}
          </>
        );
      },
    },
    {
      accessor: "cat_partner.sms",
      Header: "Canales",

      Cell: (rowData) => {
        let active = rowData.row.original.cat_partner;
        const channels = new Set();

        if (active.sms) {
          channels.add({
            name: "SMS",
            bg: "primary",
          });
        }

        if (active.whatsapp) {
          channels.add({
            name: "WHATSAPP",
            bg: "success",
          });
        }

        if (active.rcs) {
          channels.add({
            name: "RCS",
            bg: "secondary",
          });
        }

        if (active.email) {
          channels.add({
            name: "EMAIL",
            bg: "dark",
          });
        }

        return (
          <div className="flex justify-start gap-1">
            {Array.from(channels).map((channel, index) => (
              <Badge bg={channel.bg} key={index}>
                {channel.name}
              </Badge>
            ))}
          </div>
        );
      },
    },
    {
      accessor: "none",
      Header: "Acciones",
      disableSortBy: true,
      headerProps: {
        className: "text-center",
      },
      cellProps: {
        className: "text-center",
      },

      Cell: (rowData) => {
        let idToEdit = rowData.row.original.cat_partner.uidpartner;
        return (
          <div className="flex justify-center gap-2">
            {" "}
            <Tooltip message="Marcaciones Asignadas" placement="top">
              <button
                className="border not-sr-only rounded-lg bg-gray-100 hover:bg-gray-200 hover:text-gray-400 text-gray-700 border-none flex items-center gap-2 px-2 py-1"
                onClick={() => {
                  setPartnerIdToShow(idToEdit);
                  setShowInfoPartner(true);
                }}
              >
                <span className="material-symbols-outlined">contact_page</span>
              </button>
            </Tooltip>
            <Tooltip message="Detalles" placement="top">
              <button
                className="border not-sr-only rounded-lg bg-gray-100 hover:bg-gray-200 hover:text-gray-400 text-gray-700 border-none flex items-center gap-2 px-2 py-1"
                onClick={() => {
                  setPartnerIdToShow(idToEdit);
                  setShowInfo(true);
                }}
              >
                <span className="material-symbols-outlined">dock_to_left</span>
              </button>
            </Tooltip>
            <Tooltip message="Configuraciones" placement="top">
              <button
                className="border not-sr-only rounded-lg bg-gray-100 hover:bg-gray-200 hover:text-gray-400 text-gray-700 border-none flex items-center gap-2 px-2 py-1"
                onClick={() => {
                  setVisible({
                    visible: true,
                    data: rowData.row.original.cat_partner,
                  });
                }}
              >
                <span className="material-symbols-outlined">settings</span>
              </button>
            </Tooltip>
          </div>
        );
      },
    },
  ];
  return (
    <>
      <div>
        <Stack direction="horizontal" gap={2} className="wrappTitle">
          <h4>Lista de Usuarios para API</h4>
          <div className="ms-auto">
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => {
                setShow(true);
              }}
            >
              <AiIcons.AiOutlinePlus /> Agregar
            </Button>{" "}
          </div>
        </Stack>

        <Table
          columns={columns}
          data={partnersData}
          config={{
            search: true,
            pagination: true,
            pageSize: 10,
            perPage: 10,
            footer: true,
          }}
          loading={isLoading}
        />
      </div>
      <ModalEdit
        show={show}
        handleShow={handleShow}
        handleClose={handleClose}
        size="lg"
        title={
          idCustomer > 0 ? "Editar Usuario de API" : "Agregar Usuario de API"
        }
      >
        <CreatePartner handleClose={handleClose} idCustomer={idCustomer} />
      </ModalEdit>
      <ModalEdit
        show={showInfo}
        handleShow={handleShowInfo}
        handleClose={handleCloseInfo}
        title={"Detalle de API"}
        size="lg"
      >
        <DetailPartnerApi uidPartner={partnerIdToShow} />
      </ModalEdit>
      <ModalEdit
        show={showInfoPartner}
        handleShow={handleShowInfoPartner}
        handleClose={handleCloseInfoPartner}
        title={"Detalle de Marcaciones Asignadas"}
      >
        <div className="p-2">
          <ShortCodesByCustomer uidPartner={partnerIdToShow} />
        </div>
      </ModalEdit>
      <SettingsUserAPI
        visible={visible.visible}
        onClose={() => setVisible(false)}
        title="Canales"
        data={visible.data}
        refetch={refetch}
      />
    </>
  );
};
CustomerPartners.propTypes = {
  idCustomer: PropTypes.number,
  partnersData: PropTypes.array,
  setPartnersData: PropTypes.func,
};
export default CustomerPartners;
